// components/ImagePreview.js - Image preview component
import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../lib/utils';
import { FaSearchPlus, FaDownload } from 'react-icons/fa';

function ImagePreview({ src, alt, label, className, onClick, onDownload }) {
  if (!src) return null;
  
  const handleDownload = (e) => {
    e.stopPropagation();
    if (typeof onDownload === 'function') {
      onDownload();
    } else {
      // Default download behavior
      const link = document.createElement('a');
      link.href = src;
      link.download = `${alt || 'image'}.jpg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  
  return (
    <motion.div 
      className={cn(
        "relative rounded-xl overflow-hidden shadow-md group", 
        onClick ? "cursor-pointer" : "",
        className
      )}
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
      whileHover={{ 
        scale: 1.02,
        transition: { duration: 0.2 }
      }}
      onClick={onClick}
    >
      {label && (
        <div className="absolute top-3 left-3 bg-black/50 backdrop-blur-sm text-white px-3 py-1.5 rounded-full text-sm z-10">
          {label}
        </div>
      )}
      
      {/* Overlay with actions */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-between p-3 z-10">
        {onClick && (
          <motion.button
            className="bg-white/20 backdrop-blur-sm text-white p-2 rounded-full"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <FaSearchPlus />
          </motion.button>
        )}
        
        <motion.button
          className="bg-white/20 backdrop-blur-sm text-white p-2 rounded-full ml-auto"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={handleDownload}
        >
          <FaDownload />
        </motion.button>
      </div>
      
      {/* Image */}
      <div className="relative w-full pb-[75%] bg-gray-200">
        <img 
          src={src} 
          alt={alt || 'Preview'} 
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>
    </motion.div>
  );
}

export default ImagePreview;
